module.exports = __webpack_public_path__ + "static/img/12.50de75b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/horse/12.png
// module id = 9SEo
// module chunks = 1